// @flow

import { exposeComponents, exposeLazyComponents } from 'boot/common/reactMount';
import * as components from './components';
import * as lazyComponents from './components.lazy';

exposeComponents(components);
exposeLazyComponents(lazyComponents);
